export enum JoinType {
  and = 0,
  or = 1
}